export const AppState = {
  hasModalOpen: false
};
